export default "<h3>August 20, 2018</h3>\r\n<p>Update 0.2 fixes some bugs.</p>";